import React from "react";
import Navbar from "../../components/layout/Navbar";
import "../../App.css";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="Error">
          <Navbar />
          <div className="DivError">
            <h1>IRISL</h1>
            <h2>Dear user, the services did not run.</h2>
            <h3>Log out of your account</h3>
            <p>Try again after a few minutes.</p>
            <div
              className="DivImageError"
              onClick={() => window.location.reload()}
            >
              <img
                src="/assets/images/error/error500.png"
                alt="Js Ai Studio"
                className="ImageError"
                loading="lazy"
                style={{
                  filter: "blur(10px)",
                  transition: "filter 0.5s ease",
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "/assets/images/error/error500.png";
                }}
                onLoad={(e) => {
                  e.target.style.filter = "blur(0px)";
                }}
              />
            </div>
            <h3>Click on the image to reset the page.</h3>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
